<div class="pinch-zoom-content" [class.pz-dragging]="isDragging">
  <ng-content>
  </ng-content>
</div>
@if (isControl()) {
  <button class="pz-zoom-button pz-zoom-control-position-bottom" mat-mini-fab color="primary" (click)="toggleZoom()"
    >
    <mat-icon>
      @if (isZoomedIn) {
        zoom_out
      } @else {
        zoom_in
      }
    </mat-icon>
  </button>
}

